import { render, staticRenderFns } from "./FacilityTable.vue?vue&type=template&id=4e510990&"
import script from "./FacilityTable.vue?vue&type=script&lang=js&"
export * from "./FacilityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports